// A hiscore list (rank, name, time, details), used by the Tab overlay and the menus.

import type { Board } from '../online/client';
import { DT } from '../sim/constants';
import { fmtTime } from './hud';

export const ago = (ms: number) => {
  const d = (Date.now() - ms) / 1000;
  if (d < 3600) return Math.max(1, Math.round(d / 60)) + ' min ago';
  if (d < 86400) return Math.round(d / 3600) + ' h ago';
  if (d < 86400 * 60) return Math.round(d / 86400) + ' d ago';
  return new Date(ms).toLocaleDateString();
};

/** Fill an <ol> with a board's rows; `me` (lower-case name) is highlighted. */
export function fillBoard(list: HTMLElement, data: Board, me: string | undefined, myName = 'You') {
  list.textContent = '';
  const row = (rank: number, name: string, ticks: number, sub: string, mine: boolean) => {
    const li = document.createElement('li');
    if (mine) li.className = 'me';
    const r = document.createElement('span');
    r.className = 'rank';
    r.textContent = String(rank);
    const n = document.createElement('span');
    n.className = 'who';
    n.textContent = name;
    const t = document.createElement('span');
    t.className = 'time';
    t.textContent = fmtTime(ticks * DT);
    const s = document.createElement('span');
    s.className = 'sub';
    s.textContent = sub;
    li.append(r, n, t, s);
    list.append(li);
  };
  for (const t of data.top)
    row(
      t.rank,
      t.name,
      t.ticks,
      `${t.jumps} jumps · ${t.sync}% sync · ${ago(t.date)}${t.verified ? '' : ' · unchecked'}`,
      t.name.toLowerCase() === me,
    );
  if (data.me && data.me.rank > data.top.length) row(data.me.rank, myName, data.me.ticks, '', true);
}
